<script setup lang="ts">
import { cva } from 'class-variance-authority'
import type { Types } from '@/types/components/BAlert'

export interface Props {
    type?: Types
    title?: string
    content?: string
}

withDefaults(defineProps<Props>(), {
    type: `info`,
    title: '',
    content: ''
})

const alertClasses = cva(`rounded border !px-4 !py-2`, {
    variants: {
        type: {
            info: `border-info-500 bg-info-500/10 !text-info`,
            success: `border-success-500 bg-success-500/10 !text-success`,
            warning: `border-warning-500 bg-warning-500/10 !text-warning`,
            danger: `border-danger-500 bg-danger-500/10 !text-danger`
        }
    }
})
</script>

<template>
    <div :class="alertClasses({ type })">
        <p
            v-if="title"
            class="text-base font-medium">
            {{ title }}
        </p>

        <p
            v-if="content"
            class="whitespace-pre-wrap">
            {{ content }}
        </p>
        <slot v-else />
    </div>
</template>
